// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wand';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m.563 17.438 11.25-11.25m-3.938 0H6.187m11.251 0H15.75m0-3.938-1.193 1.193M11.813 2.25V.562m0 11.251v-1.688M9.068 3.443 7.875 2.25m7.875 7.875-1.193-1.193'
  />
);

export const viewBox = '0 0 18 18';
